/*
 * Macaron -> Maison Andre redirect (click-interception only).
 *
 * The Macarons collection and its individual products are no longer sold
 * directly on this site -- shoppers are sent to our partner Maison Andre
 * (https://www.maison-andre.net) instead.
 *
 * The Macarons collection page and the 404 page (served when a bookmarked
 * or linked macaron product URL is visited) each render their own on-page
 * explanation with a real clickable "Shop Macarons at Maison Andre" link
 * (see sections/main-collection-product-grid.liquid and
 * sections/main-404.liquid) -- those are plain <a href target="_blank">
 * buttons, so they are never blocked by a popup blocker and need no JS.
 *
 * This script is defense-in-depth for the one remaining case those
 * templates cannot cover: an in-site link (nav, search result, related
 * products, cart, an old internal link, etc.) that still points straight
 * at one of the 9 individual macaron PRODUCT pages. Clicking such a link
 * is intercepted, a brief on-page banner explains the redirect, and a NEW
 * browser tab opens to Maison Andre -- the current tab / page is left
 * alone (per the merchant's request: "redirect ... in a new window").
 *
 * window.open() is called SYNCHRONOUSLY inside the click handler, with no
 * setTimeout delay, so it stays inside the browser's trusted user-gesture
 * window and is not blocked as a popup.
 *
 * Loaded once, sitewide, via layout/theme.liquid -- same pattern as
 * assets/delivery-pickup-scheduler.js. Cheap no-op on every page/click
 * that has nothing to do with macarons.
 */
(function () {
  var DESTINATION_URL = 'https://www.maison-andre.net';

  // Handles of the products in the Macarons collection at the time this was
  // written (copied verbatim from the Admin API -- several contain emoji
  // that Shopify mangles into odd hyphenated fragments in the URL slug, so
  // these must match character-for-character, not be retyped/reconstructed).
  // If new macaron products are added later, add their handle here too.
  var PRODUCT_HANDLES = [
    'breast-cancer-awareness-macarons',
    'branded-✈️🏝️💝-macarons',
    'my-sweet-16-👧🏽-macarons',
    'superheroes-🏽-️-🏽-️-macarons',
    'graduation-🎓-macarons',
    'macarons-💘-valentines',
    'qatar-national-day-🌴🌴🐪-macarons',
    'macarons-for-ramadan-🌙🐪',
    'eid-al-adha-🐑-macarons'
  ];

  function normalize(pathname) {
    var p;
    try {
      p = decodeURIComponent(pathname);
    } catch (e) {
      p = pathname;
    }
    if (p.length > 1 && p.charAt(p.length - 1) === '/') {
      p = p.slice(0, -1);
    }
    return p;
  }

  function isMacaronProductPath(pathname) {
    var p = normalize(pathname);
    for (var i = 0; i < PRODUCT_HANDLES.length; i++) {
      if (p === '/products/' + PRODUCT_HANDLES[i]) {
        return true;
      }
    }
    return false;
  }

  function showBanner() {
    var existing = document.getElementById('maison-andre-redirect-banner');
    if (existing) {
      existing.parentNode.removeChild(existing);
    }
    var banner = document.createElement('div');
    banner.id = 'maison-andre-redirect-banner';
    banner.setAttribute('role', 'status');
    banner.style.cssText =
      'position:fixed;top:0;left:0;right:0;z-index:99999;' +
      'background:#1c1c1c;color:#fff;text-align:center;' +
      'padding:12px 16px;font-size:14px;font-family:sans-serif;' +
      'box-shadow:0 2px 6px rgba(0,0,0,0.2);';
    banner.textContent =
      'Macarons are now available through our partner Maison Andre — opening in a new tab.';
    document.body.appendChild(banner);
    setTimeout(function () {
      if (banner.parentNode) {
        banner.parentNode.removeChild(banner);
      }
    }, 6000);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('a[href]') : null;
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (!isMacaronProductPath(url.pathname)) return;

      event.preventDefault();
      showBanner();
      window.open(DESTINATION_URL, '_blank', 'noopener');
    },
    true
  );
})();
